import React from 'react';
import { SelectArrow } from '@lt/components/icons-react/userflow';

export const DropdownIndicator = () => <SelectArrow width="10px" />;
